import utils from './utils'

const canvas = document.querySelector('canvas')
const c = canvas.getContext('2d')

const scoreElement = document.getElementById('score')
let score = 0

canvas.width = innerWidth
canvas.height = innerHeight - 18

const mouse = {
  x: innerWidth / 2,
  y: innerHeight - 18 / 2,
  dx: 0,
  dy: 0,
  down: false,
  intersect: false
}

var ball = null
let gravity = 1
let friction = 0.800001
let mass = 0.9945

const colors = ['#2185C5', '#7ECEFD', '#FFF6E5', '#FF7F66', 'black', 'blue', 'red', 'green', 'orange', 'yellow']

// Event Listeners
addEventListener('mousemove', (event) => {
  mouse.x = event.clientX
  mouse.y = event.clientY
  mouse.dx = event.movementX
  mouse.dy = event.movementY

  if(ball){
    ball.x = event.clientX
    ball.y = event.clientY
    ball.dx = 0
    ball.dy = 0
    ball.gravity = 0
  }else if(mouse.down){
    const pos = {
      x: event.clientX,
      y: event.clientY
    };
  
    var intersectedBall = objects.find(ball => isIntersect(pos, ball));

    if(intersectedBall){
      intersectedBall.dx += mouse.dx
      intersectedBall.dy += mouse.dy
      mouse.intersect = true
      score += 1
      scoreElement.innerHTML = score
    }
  }
})

addEventListener('mousedown', (event) => {

  mouse.down = true

  const pos = {
    x: event.clientX,
    y: event.clientY
  };

  var clickedBall = objects.find(ball => isIntersect(pos, ball));

  if(clickedBall){
    ball = clickedBall
    console.log("Grabed ball: " + ball.id)
  }
});

addEventListener('mouseup', (event) => {
  mouse.down = false
  if(ball){
    console.log("Droped ball: " + ball.id)
    ball.gravity = gravity
    ball.dx = mouse.dx
    ball.dy = mouse.dy
    ball = null
  } else {
    if(!mouse.intersect){
      score = 0
      scoreElement.innerHTML = score
      init()
    }else{
      mouse.intersect = false
    }
  }
});

addEventListener('resize', () => {
  canvas.width = innerWidth
  canvas.height = innerHeight - 18
  score = 0
  scoreElement.innerHTML = score
  init()
})

// Objects
class Ball {
  constructor(id, x, y, dx, dy, radius, color) {
    this.x = x
    this.y = y
    this.dy = dy
    this.dx = dx
    this.radius = radius
    this.color = color
    this.arc = null
    this.id = id
    this.gravity = gravity
  }

  draw() {
    c.beginPath()
    this.arc = c.arc(this.x, this.y, this.radius, 0, Math.PI * 2, false)
    c.fillStyle = this.color
    c.fill()
    c.stroke()
    c.closePath()
  }

  colision(ball){

    this.dx = ball.dx * Math.sign(ball.dx)
    this.dy = ball.dy * Math.sign(ball.dy)

    ball.dx = -ball.dx
    ball.dy = -ball.dy

    this.x += (1 * Math.sign(this.dx))
    ball.x += (1 * Math.sign(ball.dx))
  }

  update(zero) {

    if(this.y + this.radius + this.dy > canvas.height){
      this.dy = -this.dy * friction
    }else if(this.y - this.radius + this.dy < zero){
      this.dy = -this.dy
    }else {
      this.dy += this.gravity
    }

    if(this.x + this.radius + this.dx > canvas.width || this.x - this.radius + this.dx < 0){
      this.dx = -this.dx
    } else {
      this.dx = this.dx * mass
    }

    this.y += this.dy
    this.x += this.dx
    this.draw()
  }
}

function isIntersect(point, circle) {
  return Math.sqrt((point.x-circle.x) ** 2 + (point.y - circle.y) ** 2) < circle.radius;
}

function getDistance(x1, y1, x2, y2){
  let xDistance = Math.abs(x2 - x1)
  let yDistance = Math.abs(y2 - y1)

  return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2))
}

// Implementation
let objects
function init() {
  objects = []

  for (let i = 1; i <= 50; i++) {
    var radius = utils.randomIntFromRange(20, 50)
    var x = utils.randomIntFromRange(0 + radius, canvas.width - radius)
    var y = utils.randomIntFromRange(0 + radius, canvas.height - radius)
    var dx = utils.randomIntFromRange(-2, 2)
    var dy = utils.randomIntFromRange(-2, 2)
    var color = utils.randomColor(colors)
    objects.push(new Ball(i, x, y, dx, dy, radius, color))
  }
}

// Animation Loop
function animate() {
  requestAnimationFrame(animate)
  c.clearRect(0, 0, canvas.width, canvas.height)
  // c.fillText(`x:${mouse.x}, y:${mouse.y}`, mouse.x, mouse.y)

  let colisions = []
  objects.forEach(ball => {
    let zero = 0
    // objects.forEach(otherBall => {
    //   if(ball.id !== otherBall.id){
    //     let distance = getDistance(ball.x, ball.y, otherBall.x, otherBall.y)
    //     if(distance < ball.radius + otherBall.radius){
    //       let alreadyColided = false
    //       colisions.forEach(colision => {
    //         if(colision.ball == otherBall.id && colision.otherBall == ball.id){
    //           alreadyColided = true
    //         }
    //       })

    //       if(!alreadyColided){
    //         ball.colision(otherBall)
    //         colisions.push({ball: ball.id, otherBall: otherBall.id})
    //         zero = ball.y + ball.radius
    //       }
    //     }
    //   }
    // })
    ball.update(zero)
  })
}

init()
animate()
